module.exports = {
          srcSet: __webpack_public_path__ + "5ca292384d037cbac1689c175ffbb48a-120.png"+" 120w",
          images:[ {path: __webpack_public_path__ + "5ca292384d037cbac1689c175ffbb48a-120.png",width: 120,height: 33}],
          src: __webpack_public_path__ + "5ca292384d037cbac1689c175ffbb48a-120.png",
          toString:function(){return __webpack_public_path__ + "5ca292384d037cbac1689c175ffbb48a-120.png"},
          
          width: 120,
          height: 33
        }